import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import * as Chart from 'chart.js';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ContestAndIncentiveDetailsService } from '../services/contest-and-incentive-details.service';
import { OfflineService } from 'src/app/offline/offline.service';

@Component({
  selector: '',
  template: '',
})
export class ContestDashboardSearchHandler
  extends BaseSearchComponent<ContestAndIncentiveDetailsService>
  implements OnInit
{
  @Output() closeChart = new EventEmitter<string>();
  public chartOptions;
  public searchName: string;
  public contestOriginalJsonData;

  constructor(
    public agentService: ContestAndIncentiveDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(agentService, router, headerService);
    this.searchName = 'SearchContest';
  }

  ngOnInit() {
    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      hover: {
        mode: 'index',
        intersect: false,
      },
      scales: {
        xAxes: [
          {
            scaleLabel: {
              display: true,
              fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
              fontColor: '#000',
            },
            ticks: {
              fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
              fontColor: '#000',
            },
            stacked: false,
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              max: 100,
              fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
              fontColor: '#000',
            },
            scaleLabel: {
              display: true,
              labelString: 'Percentage',
              fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
              fontColor: '#000',
            },
            stacked: false,
          },
        ],
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
          fontColor: '#000',
        },
      },
      tooltips: {
        mode: 'nearest',
        intersect: true,
        bodyFontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
        callbacks: {
          label: function (tooltipItem, data) {
            const label = data.datasets[tooltipItem.datasetIndex].label || '';
            const value = tooltipItem.yLabel;
            return `${label}: ${value}%`;
          },
        },
      },
      title: {
        display: true,
        text: 'Shortfall Percentage by Criteria',
        fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
        fontColor: '#000',
      },
    };
    this.agentService.find(this.searchName).subscribe(
      (searchList) => {
        const list = JSON.parse(JSON.stringify(searchList));
        this.contestOriginalJsonData = list.data.searchResultData;
      },
      (error) => {
        console.log('Get search list failed.', error);
      }
    );
  }

  onCloseClick() {
    this.closeChart.emit(Chart);
  }
}
